import type { AudioFileSource } from '@/features/media-file/domain/models/media-file.ts'
import type { Voice } from '@/features/voice/domain/models/voice.ts'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url'
import useMediaStore from '@/shared/store/media.store.tsx'
import { updateClip } from './update-clip.ts'
import { refreshAudioMix } from '@/shared/store/use-cases/refresh-audio-mix.ts'
import { useHistoryStore } from '@/shared/store/history.store.tsx'
import { createSTSSpeech } from '@/features/speech/domain/use-cases/create-sts-speech.ts'
import { getSourceId } from '@/features/media-file/domain/use-cases/get-source-id.ts'

export const updateSpeechClip = async (
  clipId: string,
  scriptID: string,
  source: AudioFileSource,
  voice: Voice,
  expressive = false
): Promise<void> => {
  const fileId = await getSourceId(source)
  if (!fileId) throw new Error('File ID not found')

  updateClip(clipId, {
    name: voice.name,
    mediaId: '',
    duration: source.mediaFile?.duration ?? 0,
  })

  const { addMedia } = useMediaStore.getState()
  const result = await createSTSSpeech(scriptID, fileId, voice, expressive)
  const buffer = await getAudioBufferFromAudioUrl(result.speechUrl)

  // Update the clip with new data
  addMedia(result.speechId, buffer)
  updateClip(clipId, {
    name: voice.name,
    mediaId: result.speechId,
    src: result.speechUrl,
    duration: buffer.duration,
  })

  useHistoryStore.getState().saveSnapshot()
  void refreshAudioMix(false)
}
